<template>
  <RootSystemGate>
    <vs-tabs>
      <vs-tab
        label="ตั้งค่าปิดเปิดระบบ"
        icon-pack="feather"
        icon="icon-settings"
      >
        <SettingsPanel :group-ids="['system', 'qr', 'payment']" />
      </vs-tab>
      <vs-tab label="ตั้งค่าบริษัท" icon-pack="feather" icon="icon-home">
        <SettingsPanel :group-ids="['company']" />
      </vs-tab>
      <vs-tab label="ตั้งค่าอีเมล" icon-pack="feather" icon="icon-mail">
        <SettingsPanel :group-ids="['email', 'security']" />
      </vs-tab>
      <vs-tab
        label="ตั้งค่าผู้มีอำนาจลงนาม"
        icon-pack="feather"
        icon="icon-edit"
      >
        <SignerSettings />
      </vs-tab>
      <vs-tab label="ตั้งเวลา Task" icon-pack="feather" icon="icon-clock">
        <TaskSchedules />
      </vs-tab>
    </vs-tabs>
  </RootSystemGate>
</template>

<script>
import RootSystemGate from "../RootSystemGate.vue";
import SettingsPanel from "./Components/SettingsPanel.vue";
import SignerSettings from "./Components/SignerSettings.vue";
import TaskSchedules from "./Components/TaskSchedules.vue";

export default {
  components: { RootSystemGate, SettingsPanel, SignerSettings, TaskSchedules },
};
</script>
